import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { defaultDocumentMeta } from '../../data/defaultDocumentMeta.js';

const UpdateDocumentMeta = ({ title, description, keywords, canonicalUrl }) => {
    const metaTitle = title || defaultDocumentMeta.title;
    const metaDescription = description || defaultDocumentMeta.description;
    const metaKeywords = keywords || defaultDocumentMeta.keywords;
    const metaCanonicalUrl = canonicalUrl || defaultDocumentMeta.canonicalUrl;
    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <link rel="canonical" href={metaCanonicalUrl} />
        </Helmet>
    );
};

UpdateDocumentMeta.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    canonicalUrl: PropTypes.string,
};

export default UpdateDocumentMeta;